import styled from '@emotion/styled'
import { StyledLinkProps, BREAKPOINTS } from 'utils/styled'

export const SStickyMobileHeader = styled.div([
  { display: 'none' },
  BREAKPOINTS.MD.css({
    display: 'block',
    position: 'sticky',
    top: 0,
    left: 0,
    width: '100%',
    zIndex: 3,
  }),
])

export const SStaticDesktopHeader = styled.div([
  BREAKPOINTS.MD.css({
    display: 'none',
  }),
])

export const SContainer = styled.div<StyledLinkProps>`
  display: flex;
  flex-direction: row;
  height: 100%;
`

export const SMainContent = styled.div<StyledLinkProps>`
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;

  position: relative;
  z-index: 1;

  @media ${BREAKPOINTS.MD.max} {
    max-height: unset;
  }
`

export const SSideContent = styled.div`
  display: flex;
  align-items: stretch;
  flex-shrink: 0;

  position: sticky;
  height: 100vh;
  top: 0;
  z-index: 3;

  overflow-y: auto;

  @media ${BREAKPOINTS.MD.max} {
    overflow-y: unset;
    top: unset;
    position: static;
    height: unset;
  }
`
